import type { SettingsV1GeneralImagesUrls } from '@sdk/Api'
import { writable } from 'svelte/store'

export const tenantImages = writable<SettingsV1GeneralImagesUrls>({
	lightModeLogo: null,
	darkModeLogo: null,
	favicon: null,
})
